var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader?{\"sourceMap\":true}!css-loader?{\"sourceMap\":true,\"minimize\":false,\"importLoaders\":1,\"alias\":{\"/assets\":\"/app/src/assets\",\"/static\":\"/app/src/static\"}}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-36b5e9bc\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?{\"indentedSyntax\":true}!sass-resources-loader?{\"resources\":[\"/app/src/assets/sass/_mixins.sass\",\"/app/src/assets/sass/_variables.sass\"]}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./representative-data.vue")
}
var normalizeComponent = require("!../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"babelrc\":false,\"cacheDirectory\":true,\"presets\":[[\"/app/node_modules/babel-preset-vue-app/dist/index.common.js\",{\"targets\":{\"ie\":9,\"uglify\":true}}]]}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./representative-data.vue"
import __vue_script__ from "!!babel-loader?{\"babelrc\":false,\"cacheDirectory\":true,\"presets\":[[\"/app/node_modules/babel-preset-vue-app/dist/index.common.js\",{\"targets\":{\"ie\":9,\"uglify\":true}}]]}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./representative-data.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-36b5e9bc\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"object\":\"src\",\"embed\":\"src\"},\"preserveWhitespace\":false,\"buble\":{\"transforms\":{}}}!../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./representative-data.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/stepper/representative-data.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-36b5e9bc", Component.options)
  } else {
    hotAPI.reload("data-v-36b5e9bc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/stepper/representative-data.vue
// module id = ./src/components/stepper/representative-data.vue
// module chunks = 0 1 2 3